import { useAction, useAtom } from "@reatom/npm-react";
import { Block } from "../../components/Block/Block";
import { Header } from "../../components/Header/Header";
import { UserLine } from "../../components/UserLine/UserLine";
import s from "./style.module.scss";
import {
  freelanceAction,
  freelanceAtom,
  isLoadingFreelanceAtom,
} from "../../core/reatom/state/search/search";
import { Card } from "../../components/Card/Card";
import { FlexWrapper } from "../../components/FlexWrapper/FlexWrapper";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { isCardViewAtom } from "@/core/reatom/state/CardView";
import clsx from "clsx";
import { CardViewSwithcer } from "@/components/CardViewSwithcer/CardViewSwithcer";
import { UIButton } from "@/components/UIButton/UIButton";
export const FreelancerPage = () => {
  const { id } = useParams();
  const [freelancerProducts] = useAtom(freelanceAtom);
  const [isLoadingFreelance] = useAtom(isLoadingFreelanceAtom);
  const handleSearch = useAction(freelanceAction);

  useEffect(() => {
    if (!freelancerProducts?.page && !isLoadingFreelance) {
      handleSearch({ user_id: Number(id) });
    }
  }, [id, freelancerProducts, isLoadingFreelance]);
  const [isCardView] = useAtom(isCardViewAtom);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();

  return (
    <FlexWrapper className={s.flexWrapper}>
      <Block borderRadius="bottom" className={s.header}>
        <Header title="Услуги автора" />
        <Block borderRadius="bottom" className={s.block}>
          <UserLine onClick={() => {}} />
        </Block>
      </Block>
      <Block
        borderRadius="top"
        className={s.cardBlock}
        wihoutPadding={isCardView}
        onScroll={(e) => setScrollPosition(e.currentTarget.scrollTop)}
      >
        <div>
          <div
            className={clsx(s.gridContainer, {
              [s.cardGrid]: !isCardView,
              [s.listGrid]: isCardView,
            })}
          >
            {freelancerProducts?.items.map((item) => (
              <Card
                src={item.preview_files[0]?.url}
                price={`${item.price.amount.toLocaleString("ru-RU")} ₽`}
                description={item.title}
                // isCardViewProps
                id={item.id}
                waitingTime={item.days}
                className={s.card}
              />
            ))}
          </div>
        </div>
      </Block>{" "}
      {freelancerProducts && (
        <CardViewSwithcer scrollY={scrollPosition} className={s.switcher} />
      )}
      <Block borderRadius="top" className={s.epic}>
        <UIButton
          fontType={"primary-2"}
          color="inverted"
          className={clsx(s.button, s.back)}
          onClick={() => navigate(-1)}
        >
          Вернуться назад
        </UIButton>
      </Block>
    </FlexWrapper>
  );
};
